module.exports = __webpack_public_path__ + "img/questions.ba515d74.png";